import React, { useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { useHistory } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { getTransactionAction } from 'redux/reducers/apiReducers/getTransactionReducer'
import { screenLoadingAction } from 'redux/actions'

const ReceiveConfirmationView = ({ t, i18n, setIsError }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { transId, transOwner } = useParams()

  useEffect(() => {
    let fulfillmentStatuses = ['PAYMENTSUCCEEDED', 'FULFILLMENTVERIFIED', 'SENTFORFULFILLMENT', 'ERROR']
    try {
      dispatch(screenLoadingAction())
      dispatch(getTransactionAction(transId))
        .then((res) => {
          let fulfillmentStatus = res['data']['fulfillmentStatus']
          i18n.changeLanguage(res['data']['lang'])
          if (fulfillmentStatuses.find((each) => each === fulfillmentStatus) && res['data']['paymentTransactionNum']) {
            history.push({
              pathname: `/${i18n.language}${t('routes.confirmation')}`,
              state: {
                transNum: res['data']['paymentTransactionNum'],
                transId: transId,
                emailAddress: res.data.gpsRequest.email,
                transOwner: transOwner,
              },
            })
          } else if (fulfillmentStatus === "SENTFORPAYMENT") {
            history.push(`/${i18n.language}${t('routes.review_summary')}?fulfillmentStatus=SENTFORPAYMENT`)
          } else {
            history.push(`/${i18n.language}${t('routes.review_summary')}`)
          }
          dispatch(screenLoadingAction())
        })
        .catch((e) => {
          console.log(e)
          setIsError(true)
          dispatch(screenLoadingAction())
        })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [dispatch, history, i18n, setIsError, t, transId, transOwner])

  return <div className="container"></div>
}

export default withTranslation('common')(ReceiveConfirmationView)
